export default __webpack_public_path__ + "static/media/Twitter.4562a80c.svg";